// Variantes du Logo — module SÉPARÉ du composant : exporter cette constante
// depuis index.tsx cassait le Fast Refresh de Vite (module non composant-seul),
// et chaque édition provoquait un rechargement complet de la page en dev.
export const logoVariants = [
  'account',
  'plus',
  'trash',
  'rename',
  'stop',
  'arrow',
  'arrow-right',
  'back',
  'add',
  'bell',
  'check',
  'info',
  'blitz',
  'error',
  'euro',
  'close',
  'crown',
  'filter',
  'folder',
  'param',
  'logout',
  'search',
  'settings',
  'tag',
  'basket',
  'cube',
  'globe',
  'star',
  'message',
  'discord',
  'external-link',
  'payment',
  'download',
] as const;
export type LogoVariant = (typeof logoVariants)[number];
